<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row>
              <el-col :md="6" :lg="6">
                <el-input :rows="1" placeholder="推类名称" v-model="params.pcate_name" clearable size="mini">
                  <el-button slot="append" icon="el-icon-search" @click="pcateSearch"></el-button>
                </el-input>
              </el-col>
              <el-col :md="9" :lg="9">
                <el-button size="mini" type="primary" @click="addSkuPromotecate">新增推类</el-button>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col>
                只看售价不同：
                <el-switch v-model="params.is_diff" active-value="1" inactive-value="0"
                  @change="acitonIsDiff()" active-color="#13ce66" inactive-color="#ff4949">
                </el-switch>
              </el-col>
            </el-row> -->
            <el-table :data="list" style="width: 100%" v-loading="loading" element-loading-text="数据加载中">
                <el-table-column prop="id" label="推类ID" width="120"></el-table-column>
                <el-table-column prop="pcate_name" label="推类名称" width="120"></el-table-column>
                <el-table-column prop="pcate_ratio" label="分佣比例"></el-table-column>
                <el-table-column prop="created_at" label="创建时间">
                  <template slot-scope="scope">
                    {{ scope.row.created_at | datetime('yyyy-MM-dd hh:mm:ss') }}
                  </template>
                </el-table-column>
                <el-table-column prop="updated_at" label="更新时间">
                  <template slot-scope="scope">
                    {{ scope.row.updated_at | datetime('yyyy-MM-dd hh:mm:ss') }}
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="market_price" label="商品售价" width="120">
                  <template slot-scope="scope">
                    ￥{{ scope.row.price / 100 }}
                  </template>
                </el-table-column> -->
                <el-table-column label="操作" width="130">
                  <template slot-scope="scope">
                    <el-button type="text" @click="editSkuPromotecate(scope.row)" class="btn-gap">编辑</el-button>
                  </template>
                </el-table-column>
            </el-table>
            <div class="content-center content-top-padded">
              <el-pagination
                  background
                  layout="total, prev, pager, next"
                  @current-change="handleCurrentChange"
                  :current-page.sync="params.page"
                  :total="total_count"
                  :page-size="params.pageSize">
              </el-pagination>
            </div>
        </div>
        <router-view></router-view>
        <el-dialog title="新增商品推类" :visible.sync="skuPromotecateDialog" :before-close="handleCancelPromotecateDialog">
          <el-form label-width="210px">
            <el-form-item class="content-center" label="推类名称">
              <el-row>
                <el-col :md="16" :lg="16">
                  <el-input placeholder="商品推类名称" v-model="form.pcate_name" clearable></el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item class="content-center" label="分佣比例">
              <el-row>
                <el-col :md="16" :lg="16">
                  <el-input placeholder="商品推类分佣比例，如：0.01" v-model="form.pcate_ratio" clearable></el-input>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="skuPromotecateDialog = false">取 消</el-button>
            <el-button type="primary" @click="saveSkuPromotecate">确 定</el-button>
          </div>
        </el-dialog>
    </div>
</template>
<script>
import { getSkuPromoteCateList, createSkuPromoteCate, updateSkuPromoteCate, deleteSkuPromoteCate } from '@/api/sharer'
export default {
    data() {
      return {
        loading: false,
        skuPromotecateDialog: false,
        params: {
          page: 1,
          pageSize: 20,
          pcate_name: '',
        },
        form: {
          pcate_name: '',
          pcate_ratio: '',
        },
        total_count: 0,
        list: [],
      }
    },
    methods: {
      // 获取推类列表数据
      getSkuPromotecateList() {
        this.loading = true
        console.log(this.params)
        getSkuPromoteCateList(this.params).then(res => {
          this.loading = false
          this.list = res.data.data.list
          this.total_count = res.data.data.total_count
        })
      },
      pcateSearch() {
        this.params.page = 1
        this.getSkuPromotecateList()
      },
      // 新增推类
      addSkuPromotecate(){
        this.skuPromotecateDialog = true
        this.form = {}
      },
      // 编辑推类
      editSkuPromotecate(data){
        this.skuPromotecateDialog = true
        this.form = data
      },
      // 关闭弹窗
      handleCancelPromotecateDialog() {
        this.skuPromotecateDialog = false
        this.form = {}
      },
      // 保存推类数据
      saveSkuPromotecate() {
        this.skuPromotecateDialog = false
        if (this.form.id) {
          // 编辑
          updateSkuPromoteCate(this.form.id, this.form).then(res => {
            if (res.data.data.status) {
              this.$message({
                message: '更新成功',
                type: 'success',
              })
              this.getSkuPromotecateList()
            }
          })
        } else {
          // 新增
          createSkuPromoteCate(this.form).then(res => {
            if (res.data.data.status) {
              this.$message({
                message: '保存成功',
                type: 'success',
              })
              this.getSkuPromotecateList()
            }
          })
        }
      },
      handleCurrentChange(page_num) {
        this.params.page = page_num
        this.getSkuPromotecateList()
      },
    },
    mounted() {
      this.getSkuPromotecateList()
    }
  }
</script>



// WEBPACK FOOTER //
// sku_promotecate.vue?ed02f5be